import Vue from 'vue';
import LoaderComponent from '../components/GlobalLoader.vue';

const LoaderConstructor = Vue.extend(LoaderComponent);

const LoaderPlugin = {
    install(Vue, options) {
        const loaderInstance = new LoaderConstructor({
            vuetify: options.vuetify,
            i18n: options.i18n,
        });
        loaderInstance.$mount(document.createElement('div'));
        document.body.appendChild(loaderInstance.$el);

        Vue.prototype.$loader = {
            show() {
                loaderInstance.show();
            },
            hide() {
                loaderInstance.hide();
            }
        };
    }
};

export default LoaderPlugin;